module.exports = __webpack_public_path__ + "img/checkmark.335ca4c8.svg";